import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import './MentionList.css';

const MentionList = forwardRef((props, ref) => {
	const [selectedIndex, setSelectedIndex] = useState(0);

	const selectItem = (index) => {
		const item = props.items[index];
		if (item) {
			props.command({ id: item.id, label: item.fullName });
		}
	};

	const upHandler = () => {
		setSelectedIndex((selectedIndex + props.items.length - 1) % props.items.length);
	};

	const downHandler = () => {
		setSelectedIndex((selectedIndex + 1) % props.items.length);
	};

	const enterHandler = () => {
		selectItem(selectedIndex);
	};

	useEffect(() => setSelectedIndex(0), [props.items]);

	useImperativeHandle(ref, () => ({
		onKeyDown: ({ event }) => {
			if (event.key === 'ArrowUp') {
				upHandler();
				return true;
			}

			if (event.key === 'ArrowDown') {
				downHandler();
				return true;
			}

			if (event.key === 'Enter') {
				enterHandler();
				return true;
			}

			return false;
		},
	}));

	if (props.items.length === 0) {
		return (
			<div className='mention-list'>
				<div className='mention-item empty'>No students found</div>
			</div>
		);
	}

	return (
		<div className='mention-list'>
			{props.items.map((item, index) => (
				<button
					className={`mention-item ${index === selectedIndex ? 'is-selected' : ''}`}
					key={item.id}
					onClick={() => selectItem(index)}>
					<span className='mention-name'>{item.fullName}</span>
					{item.instrument && (
						<span className='mention-instrument'>{item.instrument}</span>
					)}
				</button>
			))}
		</div>
	);
});

MentionList.displayName = 'MentionList';

export default MentionList;
